import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import bannerService from "./bannerService";
import { setServerError } from "../error500/error500Slice";


const initialState = {
  banner: {},
  isError: false,
  isSuccess: false,
  isLoading: false,
  message: "",
};

export const getBanner = createAsyncThunk(
  "banner/getBanner",
  async (slug, thunkApi) => {
    try {
      return await bannerService.getBanner(slug);
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();

      if (error.response && (error.response.status === 500 || error.response.status === 503 ) ) {
        thunkApi.dispatch(setServerError(true));
      } 

      return thunkApi.rejectWithValue(message);
    }
  }
);

export const bannerSlice = createSlice({
  name: "banner",
  initialState,
  reducers: {
    reset: (state) => initialState,
  },
  extraReducers: (builder) => {
    builder
      .addCase(getBanner.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isSuccess = true;
        state.banner = action.payload;
      })
  },
});

export const { reset } = bannerSlice.actions;
export default bannerSlice.reducer;